import React from 'react'
import Chronology from '../../components/chronology'

const HistoryView = (props) => (
  <Chronology {...props} />
)

export default HistoryView
